import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchPasskeyValidatePasscode } from '../api';
import {
  passkeyOtpValidateFailure,
  passkeyOtpValidateRequest,
  passkeyOtpValidateSuccess,
} from '../reducer/passkeyOtpValidateSlice';

const isSuccessMessage = (value: unknown): boolean => {
  if (typeof value !== 'string' || value.trim().length === 0) {
    return false;
  }
  const normalized = value.toLowerCase();
  return (
    normalized.includes('success') || normalized.includes('verified')
  );
};

const isSuccessStatus = (response: any): boolean =>
  response?.statusCode === '200' ||
  response?.statusCode === 200 ||
  response?.status === 200 ||
  response?.status === '200' ||
  response?.success === true ||
  isSuccessMessage(response) ||
  isSuccessMessage(response?.data) ||
  isSuccessMessage(response?.message);

export function* fetchPasskeyOtpValidateSaga(
  action: ReturnType<typeof passkeyOtpValidateRequest>
): Generator<any, void, unknown> {
  try {
    const response: any = yield call(
      fetchPasskeyValidatePasscode,
      action.payload
    );
    if (isSuccessStatus(response)) {
      yield put(passkeyOtpValidateSuccess());
    } else {
      yield put(passkeyOtpValidateFailure(response));
    }
  } catch (error: any) {
    yield put(passkeyOtpValidateFailure(error));
  }
}

export function* watchPasskeyOtpValidateSaga() {
  yield takeLatest(passkeyOtpValidateRequest.type, fetchPasskeyOtpValidateSaga);
}
